<template>
  <div>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorfrist"
      dark
      height="50px"     
    >
      <v-btn to="/college/gov_em/receive_govem" class="mr-5">
        <span>รับรายงานตัว พนักงานราชการ กรณี ย้าย</span>
        <v-icon>mdi-numeric-1-box</v-icon>
      </v-btn>  
      
       <v-btn to="/college/gov_em/government_employee" class="mr-5">
        <span>ข้อมูลพนักงานราชการ กรอบอัตรา</span>
        <v-icon>mdi-numeric-2-box</v-icon>
      </v-btn>

      <v-btn to="/college/gov_em/transfer_requests" class="mr-5">
        <v-badge
          v-if="pendingIncomingTransfers > 0"
          :content="pendingIncomingTransfers"
          color="error"
          overlap
        >
          <span>โยกย้ายระหว่างสถานศึกษา</span>
        </v-badge>
        <span v-else>โยกย้ายระหว่างสถานศึกษา</span>
        <v-icon>mdi-swap-horizontal-bold</v-icon>
      </v-btn>

      <v-btn to="/college/gov_em/personnel_govem" class="mr-5">
        <span>ข้อมูลพนักงานราชการ และสัญญา</span>
        <v-icon>mdi-numeric-3-box</v-icon>
      </v-btn>   
      
      
      <v-btn to="/college/gov_em/assessment_govem" class="mr-5">
        <span>รายงานผลการประเมินการปฏิบัติงาน</span>
        <v-icon>mdi-numeric-4-box</v-icon>
      </v-btn>   

        <v-btn to="/college/gov_em/cal_compensation" class="mr-5">
        <span>คำนวณค่าตอบแทน</span>
        <v-icon>mdi-numeric-5-box</v-icon>
      </v-btn>    

      <v-btn to="/college/gov_em/ResignHistoryPage" class="mr-5">
        <span>ประวัติการลาออก</span>
        <v-icon>mdi-numeric-6-box</v-icon>
      </v-btn>    

    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "HRvecPersonnelGovmenu",

  data() {
    return {
      personnels: false,
      pendingIncomingTransfers: 0
    };
  },

  async mounted() {
    try {
      const result = await this.$http.post("government_employee_transfer.list.php", {
        ApiKey: "HRvec2021"
      });
      if (result.data && result.data.status) {
        this.pendingIncomingTransfers = (result.data.incoming || []).length;
      }
    } catch (error) {
      // แค่ป้ายแจ้งเตือน ไม่กระทบการใช้งานหลักถ้าโหลดไม่สำเร็จ
    }
  },

  methods: {
    async personnelselect() {
      this.personnels = true;
    }
  },
  computed: {
    colorfrist() {
      return "#414141";
    },
  }
};
</script>

<style lang="scss" scoped></style>
